var unitPrice = "{{ pricePerUnit }} cada uno";
var unitsCount = "{{ unitsCount }} unidades";
var unitCount = "{{ unitsCount }} unidad";
var unitPriceWithQuantity = "{{ pricePerUnit }} cada uno / {{ unitsCount }} unidades";
var vatInclusive = "Incluye IVA";
var vatExclusive = "No incluye IVA";
var excludeShipping = "No incluye {{ shipping }}";
var includeShipping = "Incluye {{ shipping }}";
var shipping = "envío";
var vatAndShipping = {
	includeVatExcludeShipping: "Incluye IVA, no incluye {{ shipping }}",
	excludeVatIncludeShipping: "No incluye IVA, incluye {{ shipping }}",
	includeVatIncludeShipping: "Incluye IVA, incluye {{ shipping }}",
	excludeVatExcludeShipping: "No incluye IVA, no incluye {{ shipping }}"
};
var priceSummary = "Resumen del precio";
var priceSummaryInfoIcon = "Icono de información de resumen de precios";
var priceSummaryModal = "Modal de resumen de precios";
var priceSummaryCloseModal = "Cerrar modal de resumen de precios";
var priceSummaryTermsAndConditions = "*Para cada pedido, se fabrica una pantalla o almohadilla única y se ajusta el equipo para imprimir su diseño. ";
var priceSummaryBasePrice = "Precio base";
var priceSummarySetupFee = "Cargo de configuración*";
var priceSummarySubtotal = "Subtotal";
var differentialPrice = {
	included: "Incluido",
	forUnits: "{{ differentialPrice }} por {{ quantity }}unidades",
	forUnit: "{{ differentialPrice }} por {{ quantity }} unidad"
};
var priceFrom = "Desde {{ price }}";
var priceFromEach = "Desde {{ price }} cada uno";
var volumeDiscount = "{{volumeDiscount}}% de descuento por volumen";
var volumeDiscountPlusSale = "{{volumeDiscount}}% de descuento por volumen + Oferta";
var rangePrice = "{{xx}} - {{yy}}";
var unitRangePrice = "{{rangePrice}} cada uno";
var originalPrice = "precio original:";
var salePrice = "precio de venta actual:";
var setupFee = "{{ setupFee }} se aplica un cargo de configuración";
var noSetupFee = "Sin cargo de configuración";
var vatAndSetupFee = {
	noVatInclSetup: "Se incluye {{ setupFee }} un cargo de configuración",
	inclVatAndSetup: "Se incluye {{ setupFee }} un cargo de configuración y el IVA",
	exclVatInclSetup: "Se incluye {{ setupFee }} un cargo de configuración, no se incluye el IVA",
	inclVatSetupInclShipping: "Se incluye {{ setupFee }} un cargo de configuración y el IVA, se incluye {{ shipping }}",
	inclVatSetupExclShipping: "Se incluye {{ setupFee }} un cargo de configuración y el IVA, no se incluye {{ shipping }}",
	exclVatSetupInclShipping: "Se incluye {{ setupFee }} un cargo de configuración, no se incluye el IVA, se incluye {{ shipping }}",
	exclVatSetupExclShipping: "Se incluye {{ setupFee }} un cargo de configuración, no se incluye el IVA ni {{ shipping }}"
};
var priceFor = "{{ quantity }} por {{ price }}";
var esus = {
	unitPrice: unitPrice,
	unitsCount: unitsCount,
	unitCount: unitCount,
	unitPriceWithQuantity: unitPriceWithQuantity,
	vatInclusive: vatInclusive,
	vatExclusive: vatExclusive,
	excludeShipping: excludeShipping,
	includeShipping: includeShipping,
	shipping: shipping,
	vatAndShipping: vatAndShipping,
	priceSummary: priceSummary,
	priceSummaryInfoIcon: priceSummaryInfoIcon,
	priceSummaryModal: priceSummaryModal,
	priceSummaryCloseModal: priceSummaryCloseModal,
	priceSummaryTermsAndConditions: priceSummaryTermsAndConditions,
	priceSummaryBasePrice: priceSummaryBasePrice,
	priceSummarySetupFee: priceSummarySetupFee,
	priceSummarySubtotal: priceSummarySubtotal,
	differentialPrice: differentialPrice,
	priceFrom: priceFrom,
	priceFromEach: priceFromEach,
	volumeDiscount: volumeDiscount,
	volumeDiscountPlusSale: volumeDiscountPlusSale,
	rangePrice: rangePrice,
	unitRangePrice: unitRangePrice,
	originalPrice: originalPrice,
	salePrice: salePrice,
	setupFee: setupFee,
	noSetupFee: noSetupFee,
	vatAndSetupFee: vatAndSetupFee,
	priceFor: priceFor
};

export { esus as default, differentialPrice, excludeShipping, includeShipping, noSetupFee, originalPrice, priceFor, priceFrom, priceFromEach, priceSummary, priceSummaryBasePrice, priceSummaryCloseModal, priceSummaryInfoIcon, priceSummaryModal, priceSummarySetupFee, priceSummarySubtotal, priceSummaryTermsAndConditions, rangePrice, salePrice, setupFee, shipping, unitCount, unitPrice, unitPriceWithQuantity, unitRangePrice, unitsCount, vatAndSetupFee, vatAndShipping, vatExclusive, vatInclusive, volumeDiscount, volumeDiscountPlusSale };
